module.exports = __webpack_public_path__ + "img/pr-9.81d30565.png";